import { CardData } from './card-data';
import { StringUtils } from '../../utils/string-utils';

export class MasterKushStrainCardData extends CardData {
  override getRowTitle(): string {
    return (
      StringUtils.getStringModeOrNull(this.rowVariants?.map(v => v?.custom1)) ||
      this.rowVariantType() ||
      this.rowProductType()
    );
  }
}
